import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import DepartmentMapGrade from "./routes/DepartmentMapGrade";

export default store => ({
  path: ":departmentId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "department-map-details" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [DepartmentMapGrade(store)],
});
